import api from './api';
import {
  Workshop,
  WorkshopDetail,
  CreateWorkshopRequest,
  UpdateWorkshopRequest,
  PaginatedResponse,
  DashboardStats,
} from '../types/workshop.types';

export const workshopService = {
  async getWorkshops(params?: {
    page?: number;
    limit?: number;
    status?: string;
    category?: string;
    sortBy?: string;
    sortOrder?: string;
  }): Promise<PaginatedResponse<Workshop>> {
    const response = await api.get('/workshops', { params });
    return response.data;
  },

  async getWorkshop(id: string): Promise<WorkshopDetail> {
    const response = await api.get(`/workshops/${id}`);
    return response.data;
  },

  async createWorkshop(data: CreateWorkshopRequest): Promise<Workshop> {
    const response = await api.post('/workshops', data);
    return response.data;
  },

  async updateWorkshop(id: string, data: UpdateWorkshopRequest): Promise<Workshop> {
    const response = await api.patch(`/workshops/${id}`, data);
    return response.data;
  },

  async deleteWorkshop(id: string): Promise<void> {
    await api.delete(`/workshops/${id}`);
  },

  async getDashboardStats(): Promise<DashboardStats> {
    const response = await api.get('/workshops/stats');
    return response.data;
  },

  async getLibrary(params?: {
    page?: number;
    limit?: number;
    category?: string;
    sortBy?: string;
    sortOrder?: string;
  }): Promise<PaginatedResponse<Workshop>> {
    const response = await api.get('/workshops/library', { params });
    return response.data;
  },

  async shareToLibrary(id: string): Promise<Workshop> {
    const response = await api.patch(`/workshops/${id}/share`);
    return response.data;
  },

  async unshareFromLibrary(id: string): Promise<Workshop> {
    const response = await api.patch(`/workshops/${id}/unshare`);
    return response.data;
  },

  async cloneWorkshop(id: string): Promise<Workshop> {
    const response = await api.post(`/workshops/${id}/clone`);
    return response.data;
  },
};
